import i18n from '@/i18n'
import { makeStep } from '../../utils'
import { requireAssetWithFallback } from '@/utils'

const trackColor = (curtainTemplate, curtainType) => {
  //get from api available track colors
  //at this moment is not available
  // const availableColors = curtainTemplate.available_colors
  //small change to trigger rebuild + one more time

  const availableColors = ['white', 'black']
  const priceInfo = curtainTemplate.available_rail_types[0]
  const priceData = () => {
    if (priceInfo) {
      if (!!priceInfo.discount) {
        const original_price = priceInfo.discount.origin_price
        const discount = priceInfo.discount.discount_price
        return `<p class="text-right mb-0">
              ${i18n.t('components.fabricPicker.cardSubTitleWithPrice')}
              <br />
              <strong style="text-decoration: line-through; text-decoration-color:red;" class="text-h3 font-weight-bold primary--text">
                $${original_price}
              </strong>
              <br/>
              <strong class="text-h3 font-weight-bold" style="color: red"> $${discount}
              </strong>
            </p>`
      } else {
        return `<p class="text-right mb-0">
              ${i18n.t('components.fabricPicker.cardSubTitleWithPrice')}
              <br />
              <strong class="text-h3 font-weight-bold primary--text">
                $${priceInfo.price}
              </strong>
            </p>`
      }
    } else {
      return `<p class="text-right mb-0">
            ${i18n.t('components.fabricPicker.cardSubTitlePriceMissing')}
            </p>`
    }
  }

  if (
    curtainType !== 'pleatcurtain' ||
    !availableColors ||
    !availableColors.length
  ) {
    return null
  }
  return {
    id: 'color',
    name: i18n.t('components.stepper.trackColor.title'),
    type: 'card',
    choices: availableColors.map((availableColor) => ({
      title: i18n.t(`enums.TrackColor.${availableColor}`),
      value: availableColor,
      imgSrc: requireAssetWithFallback(
        `images/rail_track/${availableColor}.png`
      ),
      subTitle: priceData(),
      infoDialogTitle: i18n.t(`enums.TrackColor.informTitle`),
      infoDialogText: i18n.t(`enums.TrackColor.informText`),
      infoDialogImage: requireAssetWithFallback(
        `images/rail_track/${availableColor}.png`
      ),
    })),
  }
}

export default (curtainTemplate, curtainType) => {
  const stepQuestions = [trackColor(curtainTemplate, curtainType)]
  return makeStep(stepQuestions, i18n.t('components.stepper.trackColor.title'))
}
